import { EChartsOption } from 'echarts-for-react';

import { LineChartData } from '@/types';

export const prepareLineChartOptions = (medianMinValue: number, medianMaxValue: number, series: LineChartData) => {
  return {
    tooltip: {
      trigger: 'item',
      padding: 0,
      appendToBody: true,
      enterable: false,
      confine: false,
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: 'rgba(127,196,251,0.3)',
        },
      },
      formatter(params: EChartsOption) {
        const date = new Date(params.name).toLocaleString('en-US', {
          hour12: false,
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        });
        const cusSpan = +params.value[1];
        const toolTipText = params.data.tooltipText;

        return (
          `<div style='background: ${
            params.data.itemStyle?.background
              ? params.data.itemStyle?.background
              : +cusSpan.toFixed(2) > medianMaxValue
                ? '#52b36b'
                : +cusSpan.toFixed(2) >= medianMinValue && +cusSpan.toFixed(2) <= medianMaxValue
                  ? '#f9a31d'
                  : '#ed5050'
          }' class="tooltip-div">` +
          `<div>
              <span class="tooltip-month">${date}</span>
               <h2 class="tooltip-value">${cusSpan.toFixed(2)}%</h2>
            </div>` +
          `<h2 class="tooltip-text">${toolTipText}</h2></div>` +
          '</div>'
        );
      },
    },
    dataZoom: [
      {
        type: 'inside',
        start: 0,
        end: 100,
      },
      {
        start: 0,
        end: 10,
      },
    ],
    xAxis: {
      type: 'category',
      inverse: true,
      splitLine: {
        show: false,
        boundaryGap: false,
      },
      splitNumber: 2,
      axisLabel: {
        margin: 40,
        color: '#7A89A7',
        fontFamily: 'Open Sans',
        showMinLabel: true,
        showMaxLabel: true,
      },
      axisLine: {
        lineStyle: {
          color: 'transparent',
        },
      },
    },
    visualMap: {
      show: false,
      dimension: 1,
      pieces: [
        {
          lte: medianMaxValue,
          color: '#f9a31d',
        },
        {
          lte: medianMinValue,
          color: '#ed5050',
        },
        {
          gt: medianMaxValue + 0.01,
          // ToDo If we need smooth line fradient the best solution is use epsilon value
          //  gt: 50 + Number.EPSILON * 100,
          color: '#52b36b',
        },
      ],
    },
    yAxis: {
      min: 0,
      axisLabel: {
        margin: 40,
        color: '#7A89A7',
        fontFamily: 'Open Sans',
      },
      max: 100,
      splitLine: {
        show: true,
        lineStyle: {
          color: ['#ECE9F1'],
          width: 1.2,
          type: 'dashed',
        },
      },
    },
    grid: {
      left: 95,
      top: 50,
      right: 75,
      bottom: 100,
    },
    series: series.map(({ data, lineStyle }) => ({
      type: 'line',
      smoothMonotone: 'null',
      animate: true,
      smoothConstraint: true,
      showSymbol: true,
      smooth: true,
      symbolSize: 8,
      symbol: `emptyCircle`,
      select: {
        selectedMode: 'single',
        itemStyle: {
          borderWidth: 15,
          shadowBlur: 51.1,
        },
      },
      hoverAnimation: true,
      markLine: {
        silent: true,
        symbol: ['none', 'none'],
        label: { show: false },
        precision: 0,
        zlevel: 0,
        z: 0,
        lineStyle: {
          color: '#C2CEE0',
          type: 'dashed',
          opacity: 1,
          width: 2.5,
        },
        data: [
          {
            yAxis: medianMaxValue + 1,
          },
        ],
      },
      emphasis: {
        focus: 'series',
        blurScope: 'coordinateSystem',
      },
      animation: false,
      lineStyle,
      data,
    })),
  };
};
